export const getters = {
  LIST: state => state.list,
  PAGINATION: state => state.pagination,
  MODEL: state => state.model,
}
